<template>
    <div class="vue-location-card" @click="handleClick">
        <h3 class="name mb-0">{{ location.name }}</h3>

        <p class="address mb-3">
            {{ location.streetName }} {{ location.houseNumber }}<br>
            {{ location.postalCode }}, {{ location.place }}
        </p>

        <p class="opening-hours mb-3" :class="{ 'is-open': location.openingHours.isOpen || location.openingHours.aboutToOpen }">
            <template v-if="location.openingHours.aboutToOpen && !isOpen"><span>{{ translations.openAt }} {{ location.openingHours.currentDay.starthours }}</span></template>
            <template v-if="isOpen"><span>{{ translations.open }}</span> {{ translations.until }} {{ location.openingHours.currentDay.endhours }}</template>
            <template v-if="!isOpen && !location.openingHours.aboutToOpen"><span>{{ translations.closed }}</span></template>
        </p>

        <div @click.stop @mousedown.stop @mouseup.stop>
            <a :href="location.phoneNumber | phoneFormatter" @click="clickPhone(location.name, location.phoneNumber)" class="phone">{{ location.phoneNumber }}</a><br>
            <a :href="`mailto:${location.email}`" @click="clickMail(location.name, location.email)"  class="email">{{ location.email }}</a>
        </div>
    </div>
</template>

<script>
import PhoneNumberFormatter from "../../mixins/PhoneNumberFormatter";
import translations from "../../mixins/translations";

export default {
    name: "Card",

    mixins: [PhoneNumberFormatter, translations],

    props: {
        location: {
            type: Object,
            required: true,
        },
        eventBus: {}
    },

    data() {
        return {
            isMobile: window.matchMedia('(max-width: 991px)').matches,
        }
    },

    computed: {
        hasOpeningHours() {
            return ! lodash.isNil(this.location.openingHours.currentDay);
        },

        hasDistance() {
            return ! lodash.isNil(this.location.distance);
        },

        isOpen () {
            return this.hasOpeningHours && this.location.openingHours.isOpen;
        }
    },

    filters: {
        distance(value) {
            return `${value.toFixed(2)} km`
        }
    },

    mounted() {
        window.addEventListener('resize', lodash.debounce(() => {
            this.isMobile = window.matchMedia('(max-width: 991px)').matches;
        }, 250));
    },

    methods: {
        handleClick() {
            this.eventBus.$emit('location-clicked', this.location.id);
            this.eventBus.$emit('set-map-center', this.location.geo);
        },
        clickPhone(name, phone) {
            window.dataLayer.push({
                'event': 'click_phone',
                'values': [{
                    'name': name,
                    'item_name': phone
                }]
            })
        },
        clickMail(name, mail) {
            window.dataLayer.push({
                'event': 'click_mail',
                'values': [{
                    'name': name,
                    'item_name': mail
                }]
            })
        }
    }
}
</script>
